@if (!utils.mobileViewActive) {
<ng-container [ngTemplateOutlet]="dashboard"></ng-container>
} @else {
<ion-tabs #tabs (ionTabsDidChange)=" tabViewChanged($event)">
    <ion-tab tab="dashboard">
        <ng-container [ngTemplateOutlet]="dashboard"></ng-container>
    </ion-tab>
    <ion-tab tab="notifications">
        <ion-content>
            <div class="mobile-dashboard-sidebar dp-pt-s">
                <ng-container [ngTemplateOutlet]="sidebarInfos"></ng-container>
            </div>
            <app-notifications></app-notifications>
        </ion-content>
    </ion-tab>
    <ion-tab tab="tasks">
        <ion-content>
            <app-tasks></app-tasks>
        </ion-content>
    </ion-tab>

    <ion-tab-bar class="dashboard-tabs" slot="bottom">
        <ion-tab-button tab="dashboard">
            <fa-icon icon="list"></fa-icon>
            <ion-text>{{ 'header.nav.projects' | translate }}</ion-text>
        </ion-tab-button>
        <ion-tab-button tab="notifications">
            <div class="notification-icon-wrap">
                <fa-icon icon="bell"></fa-icon>
                <ion-badge class="notification-count" *ngIf="notificationCount > 0 && !mobileImportantNotificationWarningVisible">
                    {{ notificationCount }}
                </ion-badge>
                <ion-badge class="notification-important-warning" *ngIf="mobileImportantNotificationWarningVisible" color="warning">
                    <fa-icon icon="exclamation"></fa-icon>
                </ion-badge>
            </div>
            <ion-text>{{ 'notifications.title' | translate }}</ion-text>
        </ion-tab-button>
        <ion-tab-button tab="tasks">
            <div class="notification-icon-wrap">
                <fa-icon icon="list-check"></fa-icon>
                <ion-badge class="notification-count" *ngIf="openTasksCount > 0">{{ openTasksCount }}</ion-badge>
            </div>
            <ion-text>{{ 'header.nav.tasks' | translate }}</ion-text>
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>
}

<ng-template #dashboard>
    <div class="dashboard-wrap">
        <ng-container *ngIf="utils.isPhone; else defaultLayout">
            <ng-container *ngIf="shouldShowStatusMessageCardAtTop">
                <ng-container
                    *ngTemplateOutlet="statusMessageCard; context: { $implicit: statusMessage, showDismissButton: true }"
                ></ng-container>
            </ng-container>
            <app-project-list></app-project-list>
        </ng-container>
        <ng-template #defaultLayout>
            <app-project-list></app-project-list>
            <div class="dashboard-sidebar">
                <ng-container *ngTemplateOutlet="sidebarInfos"></ng-container>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #statusMessageCard let-statusMsg="$implicit" let-showDismissButton="showDismissButton">
    <ion-card class="status-message-card" *ngIf="statusMsg && statusMsg.enabled" color="{{ statusMsg.type }}">
        <ion-card-header>
            <ion-card-title>{{ statusMsg.title }}</ion-card-title>
        </ion-card-header>
        <ion-card-content class="ion-inherit-color" [innerHTML]="statusMsg.message"></ion-card-content>
        <div *ngIf="updateStatusMessageTimestamp > 0" class="status-footer ion-text-right dp-mt-s">
            <div class="footer-content">
                <small
                    ><i> {{ 'dashboard.status.last-update' | translate:{ time: updateStatusMessageTimestamp | date: "HH:mm" } }} </i></small
                >
                <ion-toolbar *ngIf="showDismissButton" color="transparent">
                    <ion-button color="dark" fill="clear" expand="block" (click)="dismissStatusMessageCard()">
                        <fa-icon icon="times" slot="start"></fa-icon>
                        {{ 'dashboard.status.dismiss' | translate }}
                    </ion-button>
                </ion-toolbar>
            </div>
        </div>
    </ion-card>
</ng-template>

<ng-template #sidebarInfos>
    <div class="sidebar-infos-wrap">
        <ion-card class="current-sync-warning ion-text-center" color="primary" *ngIf="isDokuPitSupportAccount">
            <ion-card-header>
                <ion-card-title>
                    <fa-icon icon="exclamation-circle"></fa-icon>
                    {{ 'dashboard.support-mode.title' | translate }}
                </ion-card-title>
            </ion-card-header>
            <ion-card-content>
                <div class="dp-mb-s color-white">
                    {{ 'dashboard.support-mode.message' | translate }}
                    <div *ngIf="dokuPitSupportSpoofingUsername != null">
                        <strong
                            >{{ 'dashboard.support-mode.user-faking-warning-message' | translate:{ name: dokuPitSupportSpoofingUsername }
                            }}</strong
                        >
                    </div>
                </div>
            </ion-card-content>
        </ion-card>

        <ng-container *ngTemplateOutlet="statusMessageCard; context: { $implicit: statusMessage }"></ng-container>

        <!-- UPDATE INFO -->
        <ion-card *ngIf="updateInfoVisible" color="warning">
            <ion-card-header>
                <ion-card-title>
                    <fa-icon icon="info-square"></fa-icon>
                    {{ 'dashboard.status.app-update-activated' | translate }}
                </ion-card-title>
            </ion-card-header>
            <ion-card-content>
                <div>
                    {{ 'dashboard.status.app-update-activated-message' | translate }}
                    <strong><a [routerLink]="['/updates']">{{ 'header.nav.updates' | translate }}</a></strong
                    >.
                </div>
            </ion-card-content>
        </ion-card>

        <ion-card
            class="current-sync-warning ion-text-center"
            *ngIf="syncInfo && syncInfo.currentSyncWarning != null"
            [color]="syncInfo.currentSyncWarning === 'cleanup-running' ? 'primary' : 'warning'"
        >
            <ng-container
                *ngIf="syncInfo.currentSyncWarning == 'downstream-too-long-ago' || syncInfo.currentSyncWarning == 'upstream-too-long-ago'"
            >
                <ion-card-header>
                    <ion-card-title>
                        <fa-icon icon="exclamation-circle"></fa-icon>
                        {{ "dashboard.sync-info.sync-recommended-title" | translate }}
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content [innerHTML]="'dashboard.sync-info.sync-recommended-message' | translate"></ion-card-content>
            </ng-container>
            <ng-container *ngIf="syncInfo.currentSyncWarning == 'cleanup-running'">
                <ion-card-header>
                    <ion-card-title>
                        <fa-icon icon="exclamation-circle"></fa-icon>
                        {{ 'dashboard.sync-info.cleanup-title' | translate }}
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <div class="dp-mb-s color-white" [innerHTML]="'dashboard.sync-info.cleanup-message' | translate"></div>
                    <app-loading-indicator>{{ 'dashboard.sync-info.cleanup-status-label' | translate }}</app-loading-indicator>
                </ion-card-content>
            </ng-container>
        </ion-card>

        <ion-card class="ion-text-center" color="warning" *ngIf="showVersionWarning">
            <ion-card-header>
                <ion-card-title>{{ 'dashboard.updates.appstore-version-available-title' | translate }}</ion-card-title>
            </ion-card-header>
            <ion-card-content
                class="ion-inherit-color"
                [innerHTML]="'dashboard.updates.appstore-version-available-message' | translate"
            ></ion-card-content>
        </ion-card>

        <ion-card class="ion-text-center" color="warning" *ngIf="showReloadMessage">
            <ion-card-header>
                <ion-card-title>{{ 'dashboard.updates.site-reload-recommended-title' | translate }}</ion-card-title>
            </ion-card-header>
            <ion-card-content class="ion-inherit-color">
                <ion-text style="display: block" [innerHTML]="'dashboard.updates.site-reload-recommended-message' | translate"></ion-text>
                <ion-button (click)="reloadWebsite()">
                    <fa-icon icon="arrows-rotate" slot="start"></fa-icon>
                    <ion-label>{{ 'dashboard.updates.site-reload-recommended-action' | translate }}</ion-label>
                </ion-button>
            </ion-card-content>
        </ion-card>

        <!-- ACTIVITY HISTORY -->
        <ng-container *ngIf="showStatistics">
            <app-activity-statistics></app-activity-statistics>
        </ng-container>
    </div>
</ng-template>
